/* eslint-disable no-undef */

import React, {Component} from 'react'
import {withStyles} from "@material-ui/core/styles/index";
import InputRange from "react-input-range";
import parse from "html-react-parser";
import Log from '../simple/Log'
import Checkbox from '@material-ui/core/Checkbox/index';

import { Grid, FormHelperText, FormLabel, Typography, TextField } from '@material-ui/core';

const styles = theme => ({
  errorText: {
    marginTop: theme.spacing(0.8),
    color: theme.palette.error.main + '!important'
  },
  titleValue: {
    float: 'right',
    fontWeight: 500,
    marginRight: -8,
  },
  unit: {
    minWidth: 23,
    fontSize: '1.2rem',
    textAlign: 'left',
    lineHeight: '2.2rem',
    display: 'inline-block',
    color: 'rgba(0, 0, 0, 0.87)',
    marginLeft: 5,
    fontWeight: 600,
  },
  customTitleSize: {
    marginTop: 0,
    textAlign: 'left!important',
    lineHeight: '34px'
  },
  grid: {
    marginTop: 0,
    marginBottom: 10,
    padding: '0px 12px!important'
  },
  noTopMargin: {
    marginTop: 0
  },
  questionWrapper: {},
  [theme.breakpoints.down(600)]: {
    questionWrapper: {
      padding: '4px 8px!important'
    }
  },
  titleText: {
    maxWidth: 'calc(100% - 100px)',
    display: 'inline-block',
    lineHeight: '39px'
  },
  minMaxWrapper: {
    marginTop: theme.spacing(0.8),
    color: 'rgba(0, 0, 0, 0.44)',
    fontWeight: 600,
    float: 'left',
    width: '100%',
  },
  min: {
    float: 'left',
  },
  max: {
    float: 'right',
    marginRight: 2
  },
  minMaxUnit: {
    fontSize: '75%',
    marginLeft: 2,
  },
  adminSliderGrid: {
    marginBottom: 0
  },
  checkbox: {
    padding: 0,
    marginTop: -4,
  }
});
let updateTimeout = null;
let textChangeTimeout = null;

class SliderQuestion extends Component {

  state = {
    inputTimeout: null,
    value: null,
  }

  componentDidMount() {
    this.updateState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    const calcValue = parseInt(nextProps.question.value)

    if (calcValue !== this.state.calcValue && this.props.question.adminSlider) {
      this.updateState(nextProps)
    }
  }

  updateState = (props) => {
    const calcValue = parseInt(props.question.value)

    this.logSlider = new Log({
      minpos: 0,
      maxpos: 1000,
      minval: props.question.min,
      maxval: props.question.max
    });

    let value = calcValue
    if (props.question.useLogaritmic) {
      value = this.getPos(calcValue)
    }

    this.setState({value: value, calcValue: calcValue, textValue: calcValue}, () => {
    })
  }

  getCalcValue(value) {
    const val = this.logSlider.value(value);
    const step = this.props.question.step;
    return Math.round(val / step) * step;
  }

  getPos(calcValue) {
    if (this.logSlider) {
      return parseInt(this.logSlider.position(calcValue))
    }
    return 0;
  }

  handleTextChange = (event) => {
    let value = event.target.value
    this.setState({textValue: value})

    let outsideValue = false
    if (value < this.props.question.min) {
      value = this.props.question.min
      outsideValue = true
    }
    if (value > this.props.question.max) {
      value = this.props.question.max
      outsideValue = true
    }

    let pos = value
    if (this.props.question.useLogaritmic) {
      pos = this.getPos(value)
    }

    clearTimeout(textChangeTimeout);

    if (outsideValue) {
      textChangeTimeout = setTimeout(() => {
        this.updateValue(pos)
      }, 2000);
    } else {
      this.updateValue(pos, event.target.value)
    }
    //this.props.onValueChanged(this.props.question.id, event.target.value)
  };

  handleSliderChange = (value) => {
    this.updateValue(value)
    //this.props.onValueChanged(this.props.question.id, value)
  }

  updateValue = (value, newCalcValue = null) => {
    let calcValue = value

    if (this.props.question.useLogaritmic) {
      calcValue = newCalcValue ? newCalcValue : this.getCalcValue(value)
    }

    this.setState({value: value, calcValue: calcValue, textValue: calcValue})
    clearTimeout(updateTimeout);

    updateTimeout = setTimeout(() => {
      this.props.onValueChanged(this.props.question.id, calcValue, this.props.question.itemType, this.props.question.alias)
    }, 500);
  }

  render() {
    const {classes, value, question} = this.props;
    const inputValue = this.state.value;
    const inputCalcValue = this.state.textValue ? this.state.textValue : 0;

    return (
        <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.smCols)}
              className={classes.questionWrapper + ' ' + classes.grid + ' ' + (question.name === 'laina_aika' ? classes.noTopMargin : '') + ' '
              + (this.props.question.adminSlider ? classes.adminSliderGrid : '')
              }>
          {question.title && <>
            {!question.titleSize &&
            <FormLabel component="legend" className={classes.label}>{question.title}</FormLabel>}
            {question.titleSize && <Typography variant={question.titleSize}
                                               className={classes.customTitleSize}><span
                className={classes.titleText}>{question.title}</span>
              <span className={classes.titleValue}>
                <TextField onChange={this.handleTextChange} value={inputCalcValue}
                           onFocus={(event) => event.target.select()}
                           className={'sliderTextField ' + question.cssClass}/><span
                  className={classes.unit}>{question.unit}</span></span></Typography>}
          </>}

          {inputValue !== null && !this.props.question.adminSlider && <Grid container>
            <Grid item xs={12}><InputRange
                formatLabel={() => null}
                step={question.useLogaritmic ? 1 : question.step}
                minValue={question.useLogaritmic ? 0 : question.min}
                maxValue={question.useLogaritmic ? 1000 : question.max}
                value={inputValue}
                onChange={this.handleSliderChange}/>
            </Grid>
          </Grid>}

          {inputValue !== null && this.props.question.adminSlider && <Grid container>
            <Grid item xs={4}>
              <Checkbox color="primary"
                        classes={{root: classes.checkbox}}
                        onChange={() => this.handleSliderChange(inputValue === -999999 ? 0 : -999999)}
                        checked={inputValue === -999999}/>
            </Grid>
            <Grid item xs={8}>{inputValue !== -999999 && <><InputRange
                formatLabel={() => null}
                step={question.useLogaritmic ? 1 : question.step}
                minValue={question.useLogaritmic ? 0 : question.min}
                maxValue={question.useLogaritmic ? 1000 : question.max}
                value={inputValue}
                onChange={this.handleSliderChange}/>
              {this.props.question.adminSlider && <div className={classes.smallValue}>{inputCalcValue}</div>}</>}
              {inputValue === -999999 && <div style={{minHeight: 31}}><b>Sets total score to 0</b></div>}
            </Grid>
          </Grid>}

          {question.valid === false &&
          <Grid item xs={12} style={{paddingTop: 0}}><FormHelperText
              className={classes.errorText}>{question.errorMessage}</FormHelperText></Grid>}
          {!this.props.question.adminSlider && <div className={classes.minMaxWrapper}>
            <div className={classes.min}>
              {question.min}<span className={classes.minMaxUnit}>{question.unit}</span>
            </div>
            <div className={classes.max}>
              {question.max}<span className={classes.minMaxUnit}>{question.unit}</span>
            </div>
          </div>}
          {question.description &&
          <Typography component="span">{parse(question.description)}</Typography>}
        </Grid>
    )
  }
}

export default withStyles(styles)(SliderQuestion);
